import { PokeType } from "types/pokemon/poke-type";

export enum FACTION_NAME {
  VERDANT_UNION = "Verdant Union",
  CINDERFIELDS_FIST = "Cinderfields Fist",
  TEMPEST_TRIBE = "Tempest Tribe",
  DARK_LEGION = "Dark Legion",
}

export interface FactionData {
  name: FACTION_NAME;
  types: PokeType[];
  color: string;
  emoji: string;
}

export const FACTIONS: Record<FACTION_NAME, FactionData> = {
  [FACTION_NAME.VERDANT_UNION]: {
    name: FACTION_NAME.VERDANT_UNION,
    types: [
      PokeType.GRASS,
      PokeType.WATER,
      PokeType.FAIRY,
      PokeType.BUG,
      PokeType.PSYCHIC,
      PokeType.NORMAL,
    ],
    color: "#008000",
    emoji: "🌿",
  },
  [FACTION_NAME.CINDERFIELDS_FIST]: {
    name: FACTION_NAME.CINDERFIELDS_FIST,
    types: [
      PokeType.FIRE,
      PokeType.GROUND,
      PokeType.FIGHTING,
      PokeType.ROCK,
      PokeType.STEEL,
      PokeType.NORMAL,
    ],
    color: "#FF0000",
    emoji: "🔥",
  },
  [FACTION_NAME.TEMPEST_TRIBE]: {
    name: FACTION_NAME.TEMPEST_TRIBE,
    types: [
      PokeType.ELECTRIC,
      PokeType.DRAGON,
      PokeType.FLYING,
      PokeType.ICE,
      PokeType.NORMAL,
    ],
    color: "#0000FF",
    emoji: "⚡",
  },
  [FACTION_NAME.DARK_LEGION]: {
    name: FACTION_NAME.DARK_LEGION,
    types: [PokeType.GHOST, PokeType.DARK, PokeType.POISON],
    color: "#800080",
    emoji: "🌑",
  },
};
